import { render, staticRenderFns } from "./HistoryOfForthingAgreement.vue?vue&type=template&id=5d1fb1ab&scoped=true&"
import script from "./HistoryOfForthingAgreement.vue?vue&type=script&lang=js&"
export * from "./HistoryOfForthingAgreement.vue?vue&type=script&lang=js&"
import style0 from "./HistoryOfForthingAgreement.vue?vue&type=style&index=0&id=5d1fb1ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1fb1ab",
  null
  
)

export default component.exports